import "@styles/global.css"

import { CustomQueryClientProvider } from "@queries/CustomQueryClientProvider.tsx"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { RouterProvider } from "react-router"
import { router } from "./router.tsx"

const rootElement = document.getElementById("root")

if (typeof window !== "undefined" && !window.BridgeHandler) {
  window.BridgeHandler = {
    postMessage(raw: string) {
      console.warn("BridgeHandler 미초기화:", raw)
    },
  }
}

if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <CustomQueryClientProvider>
        <ReactQueryDevtools />
        <RouterProvider router={router} />
      </CustomQueryClientProvider>
    </StrictMode>,
  )
} else {
  console.error("Root Element Not Found. Please check index.html!")
}
